import React, { useState } from 'react';
import { Box } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';

/**
 * A component for displaying Google user profile images with proper referrer policy
 * to prevent CORS and loading issues with Google's image servers.
 */
const GoogleImage = ({ 
  url, 
  alt = "Profile", 
  size = 96,
  fallbackIcon = <AccountCircle />,
  sx = {},
  onError = null
}) => {
  const [error, setError] = useState(false);

  if (!url || error) {
    return fallbackIcon ? (
      typeof fallbackIcon === 'string' ? (
        <Box
          component="img"
          src={fallbackIcon}
          alt={alt}
          sx={sx}
        />
      ) : (
        fallbackIcon
      )
    ) : null;
  }

  // Determine if we need to append size parameter
  const imageUrl = url.includes('=s') ? url : `${url}=s${size}-c`;

  const handleError = (e) => {
    setError(true);
    if (onError) {
      onError(e);
    }
  };

  return (
    <Box
      component="img"
      src={imageUrl}
      alt={alt}
      referrerPolicy="no-referrer"
      onError={handleError}
      sx={sx}
    />
  );
};

export default GoogleImage;
